<sf-loader></sf-loader>
<sf-notification></sf-notification>
<div class="formgrid grid">
    <div class="col-12 sm:col-12 md:col-12 lg:col-6">
        <sf-sub-header [title]="'label.services' | translate" [description]="'label.serviceClient' | translate">
        </sf-sub-header>
    </div>
    <div class="col-12 sm:col-12 md:col-12 lg:col-6">
        <sf-breadcrumb [model]="BREAD_CRUMB_LIST"></sf-breadcrumb>
    </div>
</div>

<p-divider></p-divider>
<div class="p-grid">
    <div class="p-col-12" style="margin-top: -18px;">


        <p-table #dt [value]="list" dataKey="id" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="pageMessage" [rowsPerPageOptions]="[25,50,100]"
            [globalFilterFields]="['code','name','description','component']"
            styleClass="p-datatable-responsive-demo p-datatable-striped" responsiveLayout="stack" [breakpoint]="'450px'"
            [showCurrentPageReport]="true" [tableStyle]="{'min-width': '50rem'}">

            <ng-template pTemplate="caption">
                <div class="flex">
                    <button pButton pRipple icon="pi pi-plus" [label]="'button.serviceNew' | translate"
                        class="p-button-primary mr-2 " style="width: 170px;" (click)="addItem()"></button>
                    <!-- <button pButton pRipple icon="pi pi-file-excel" [label]="'button.exportService' | translate"
                        class="p-button-success mr-2" style="width: 170px;" (click)="exportItem()"></button>
                    <button pButton pRipple icon="pi pi-file-import" [label]="'button.importService' | translate"
                        class="p-button-warning mr-2" style="width: 170px;" (click)="importItem()"></button> -->

                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input #filter pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            [placeholder]="'search.service' | translate" />
                        <button pButton [label]="'button.clear' | translate" class="p-button-warning mr-2 ml-2"
                            icon="pi pi-filter-slash" (click)="clear(dt, filter); filter.value = '';"></button>
                    </span>
                    <p-button icon="pi pi-refresh" (click)="getList()"></p-button>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th style="text-align: left; "><span translate>label.type</span> </th>
                    <th style="text-align: center; width: 80px;"><span translate>label.code</span> </th>
                    <th style="text-align: left; " pSortableColumn="name"><span translate>label.name</span><p-sortIcon field="name"></p-sortIcon></th>
                    <!-- <th style="text-align: center; width: 200px;" pSortableColumn="description"><span translate>label.description</span><p-sortIcon field="description"></p-sortIcon></th> -->

                    <!-- <th style="text-align: center;"><span translate>label.component</span></th> -->
                    <th style="text-align: center; width: 80px;"><span translate>label.active</span></th>
                    <th style="width: 150px; text-align: center;"><span translate>label.actions</span></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td style="text-align: center;">{{item.woOrderServiceDefaultName}}</td>
                    <td style="text-align: center;">{{item.code}}</td>
                    <td>{{item.name}}</td>
                    <!-- <td>{{item.description}}</td> -->
                    <!-- <td style="text-align: center;">{{item.excutionTime}}</td> -->
                    <!-- <td style="text-align: center;">{{item.unitValueA | number:'1.2-2'}}</td>
                    <td style="text-align: center;" *ngIf="showValueB">{{item.unitValueB | number:'1.2-2'}}</td>
                    <td style="text-align: center;" *ngIf="showTaxA">{{item.unitValueTaxA | number:'1.2-2'}}</td>
                    <td style="text-align: center;" *ngIf="showTaxB">{{item.unitValueTaxB | number:'1.2-2'}}</td>
                    <td style="text-align: center;" *ngIf="showRange">{{item.TotalRangeValueFrom | number:'1.2-2'}}</td>
                    <td style="text-align: center;" *ngIf="showRange">{{item.TotalRangeValueTo | number:'1.2-2'}}</td>                     -->
                    <!-- <td>{{item.orderServiceTemplateName}}</td> -->
                    <td>{{item.isActive == true ? 'Sim' : 'Não'}}</td>
                    <td style="text-align: center;">
                        <p-button icon="pi pi-pencil" styleClass="p-button p-button-success p-m-1 mr-1"
                            [pTooltip]="'button.edit' | translate" (click)="updItem(item)"></p-button>
                        <p-button icon="pi pi-trash" styleClass="p-button p-button-danger p-m-1 mr-1"
                            [pTooltip]="'button.delete' | translate" (click)="delItem(item)"
                            [disabled]="item.isActive || !canUpdate ? true : false"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<p-dialog [(visible)]="displayDialog" [style]="{width: '800px'}" [modal]="true" styleClass="p-fluid"
    [header]="dialogHeader">
    <ng-template pTemplate="content">
        <div style="margin-top:1px;" class="p-grid p-d-flex dialog-page">
            <div class="formgrid grid" *ngIf="isAddItem">
                <div class="field col-12 sm:col-12 md:col-12 lg:col-12 xl:col-12">
                    <label for="icon">Tipo de Serviço</label>
                    <sf-dropdown-generic appendTo="body" [list]="listServiceDefault" [id]="item.woOrderServiceDefaultId" (selectedItemOutput)="reciverFeedbackDefault($event)" required ></sf-dropdown-generic>
                    <small class="p-invalid" *ngIf="submitted && !item.woOrderServiceDefaultId"><span
                                translate>label.field_service_default_required</span></small>
                </div>
            </div>
            <div class="formgrid grid">
                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="code"><span translate>label.code</span></label>
                    <input type="text" pInputText id="code" [(ngModel)]="item.code" required [disabled]="!canUpdate"
                        tabindex="1" />
                    <small class="p-invalid" *ngIf="submitted && !item.code"><span
                            translate>label.field_code_required</span></small>
                </div>
                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="code"><span translate>label.externalCode</span></label>
                    <input type="text" pInputText id="externalCode" [(ngModel)]="item.codeExternal"
                        [disabled]="!canUpdateDefault" tabindex="2" />
                </div>
                <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
                    <label for="name"><span translate>label.name</span></label>
                    <input type="text" pInputText id="name" [(ngModel)]="item.name" required [disabled]="!canUpdate"
                        tabindex="3" />
                    <small class="p-invalid" *ngIf="submitted && !item.name"><span
                            translate>label.field_name_required</span></small>
                </div>
            </div>

            <div class="formgrid grid">
                <div class="field col-12 sm:col-12 md:col-12 lg:col-12 xl:col-12">
                    <label for="description"><span translate>label.description</span></label>
                    <textarea rows="3" cols="30" pInputTextarea id="description" [(ngModel)]="item.description"
                        [disabled]="!canUpdate" tabindex="4"
                        class="text-base text-color surface-overlay border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"></textarea>
                </div>
            </div>



            <div class="formgrid grid">
                <div class="field col-12 sm:col-12 md:col-4 lg:col-4 xl:col-4">
                    <label for="executionTime"><span translate>label.executionTime</span> (minutos)</label>
                    <p-inputNumber
                        [(ngModel)]="item.executionTime"
                        inputId="executionTime"
                        mode="decimal"
                        [disabled]="!canUpdate"
                        [min]="0"
                        [max]="50000" />

                </div>
                <div class="field col-12 sm:col-12 md:col-4 lg:col-4 xl:col-4">
                    <label for="icon"><span translate>label.icon</span></label>
                    <sf-dropdown-icon-service appendTo="body"  tabindex="5" [icon]="item.icon"
                        (chosedIcon)="reciverFeedbackIcon($event)"
                        [disabled]="!canUpdate"></sf-dropdown-icon-service>
                </div>
                <div class="field col-12 sm:col-12 md:col-2 lg:col-2 xl:col-2 mt-4">
                    <label for="icon" class="mr-3"><span translate>label.color</span></label>
                        <p-colorPicker [(ngModel)]="item.color" [disabled]="!canUpdate"></p-colorPicker>
                </div>
                <div class="field col-12 sm:col-12 md:col-2 lg:col-2 xl:col-2 mt-4">
                    <input type="checkbox" id="isActive" [(ngModel)]="item.isActive">
                    <label for="isActive"><span translate>label.active</span></label>
                </div>
            </div>

            <!-- <hr style="border: 0; border-top: 1px solid #dee2e6; margin: 1rem 0; width: 100%;"> -->

            <div class="formgrid grid">

                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="unitValueA"><span>{{labelUnitValueA}}</span></label>
                    <div class="">
                        <span translate>label.moneySymbol</span><span class="ml-2 text-semibold">{{item.unitValueA | number:'1.2-2'}}</span>
                    </div>
                </div>
                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="labelUnitValueTaxA"><span>{{labelUnitValueTaxA}}</span></label>
                    <div class="">
                        <span translate>label.moneySymbol</span><span class="ml-2 text-semibold">{{item.unitValueTaxA | number:'1.2-2'}}</span>
                    </div>
                </div>
                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="UnitValueB"><span>{{labelUnitValueB}}</span></label>
                    <div class="">
                        <span translate>label.moneySymbol</span><span class="ml-2 text-semibold">{{item.unitValueB | number:'1.2-2'}}</span>
                    </div>
                </div>
                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="UnitValueTaxB"><span>{{labelUnitValueTaxB}}</span></label>
                    <div class="">
                        <span translate>label.moneySymbol</span><span class="ml-2 text-semibold">{{item.unitValueTaxB | number:'1.2-2'}}</span>
                    </div>
                </div>

            </div>


            <div class="formgrid grid mt-2">
                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="totalRangeValueFrom"><span translate>label.totalRangeValueFrom</span></label>
                    <div class="">
                        <span translate>label.moneySymbol</span><span class="ml-2 text-semibold">{{item.totalRangeValueFrom | number:'1.2-2'}}</span>
                    </div>
                </div>
                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="totalRangeValueTo"><span translate>label.totalRangeValueTo</span></label>
                    <div class="">
                        <span translate>label.moneySymbol</span><span class="ml-2 text-semibold">{{item.totalRangeValueTo | number:'1.2-2'}}</span>
                    </div>
                </div>

                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="UnitValueTaxApp"><span>Taxa Operacional - App</span></label>
                    <div *ngIf="!canUpdateDefault">
                        <span class="p-inputgroup-addon">{{isTaxAppPercent ? "%" : ("label.moneySymbol" | translate)}}</span><span class="ml-2 text-semibold">{{item.unitValueTaxApp | number:'1.2-2'}}</span>
                    </div>
                    <div *ngIf="canUpdateDefault">
                        <p-inputNumber
                            [(ngModel)]="item.unitValueTaxApp"
                            inputId="UnitValueTaxApp"
                            mode="decimal"
                            [min]="0"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [prefix]="isTaxAppPercent ? '% ' : (('label.moneySymbol' | translate) + ' ')" />
                    </div>
                </div>
                <div class="field col-12 sm:col-12 md:col-3 lg:col-3 xl:col-3">
                    <label for="UnitValueTaxApp"><span>Taxa de Pagamento</span></label>
                    <div *ngIf="!canUpdateDefault">
                        <span class="p-inputgroup-addon">{{isTaxAppPay ? "%" : ("label.moneySymbol" | translate)}}</span><span class="ml-2 text-semibold">{{item.unitValueTaxPay | number:'1.2-2'}}</span>
                    </div>
                    <div *ngIf="canUpdateDefault">
                        <p-inputNumber
                            [(ngModel)]="item.unitValueTaxPay"
                            inputId="unitValueTaxPay"
                            mode="decimal"
                            [min]="0"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [prefix]="isTaxAppPay ? '% ' : (('label.moneySymbol' | translate) + ' ')" />

                    </div>
                </div>


            </div>



            <div class="formgrid grid">
                <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
                    <label for="icon"><span translate>Arquivos / Documentos Obrigatórios</span></label>
                    <sf-sc-archive-type-list-multi [selectedItems]="item.archiveTypeList" (chosedItem)="feedbackArchiveType($event)"></sf-sc-archive-type-list-multi>
                </div>
                <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
                    <label for="icon"><span translate>Arquivos / Documentos Opcionais</span></label>
                    <sf-sc-archive-type-list-multi [selectedItems]="item.archiveTypeListOptional" (chosedItem)="feedbackArchiveTypeOptional($event)"></sf-sc-archive-type-list-multi>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div style="float: right; display: flex; align-items: flex-end; gap: 8px;">
            <button pButton pRipple icon="pi pi-times" style="width: 120px; margin: 3px;"
                class="p-button-danger p-button-outlined p-mr-2 mt-3" [label]="'button.cancel' | translate"
                (click)="hideDialog()"></button>
            <button pButton pRipple icon="pi pi-check" style="width: 120px; margin: 3px;"
                class="p-button-success p-mr-2 mt-3" [label]="'button.confirm' | translate"
                (click)="saveItem()"></button>

        </div>
    </ng-template>
</p-dialog>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
